<template>
    <div class="box" v-show="isShowRangeSlider">
        <div class="box-header">
            <div class="box-toggle">
                محدوده قیمت
            </div>
        </div>
        <div class="box-content">
            <div>
                <input type="text" id="range">
            </div>
            <div class="btnrange">
                <input @click="applyPriceRange" class="btn btn-action btn-width blue-btn" type="button" value="اعمال محدوده قیمت" />
            </div>
        </div>
    </div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    var rangeSlider = null;
    export default {
        data() {
            return {
                isShowRangeSlider: false,
            }
        },
        methods: {
            applyPriceRange() {
                var data = { from: 0, to: 0, min: 0, max: 0 };
                if (rangeSlider != null) {
                    data.from = rangeSlider.result.from;
                    data.to = rangeSlider.result.to;
                    data.min = rangeSlider.result.min;
                    data.max = rangeSlider.result.max;
                }
                this.$parent.$data.rangeSliderValues = data;
                filterEventBus.$emit('createQueryStringParameter');
            },
            createRangeSlider(min, max, from, to) {
                if (min == max)
                    this.isShowRangeSlider = false;
                else
                    this.isShowRangeSlider = true;
                $(function () {
                    if (rangeSlider != null) {
                        rangeSlider.destroy();
                        rangeSlider = null;
                    }
                    $("#range").ionRangeSlider({
                        type: "double",
                        grid: true,
                        min: min,
                        max: max,
                        from: from,
                        to: to,
                        step: 5000,
                        prettify_separator: ",",
                        postfix: " تومان"
                    });
                    rangeSlider = $("#range").data("ionRangeSlider");
                    rangeSlider.update({
                        from: from == null ? min : from,
                        to: to == null ? max : to,
                    });
                });
            },
        },
        created() {
            filterEventBus.$on('createRangeSlider', (min, max, from, to) => {
                this.createRangeSlider(min, max, from, to);
            });

            filterEventBus.$on('resetRangeSlider', () => {
                rangeSlider.update({
                    min: rangeSlider.result.from,
                    max: rangeSlider.result.to
                });
            });

        },
        beforeDestroy() {
            filterEventBus.$off('createRangeSlider');
            filterEventBus.$off('resetRangeSlider');
        }
    }
</script>

<style scoped>
    .btnrange {
        text-align: center;
        margin-top: 8px;
    }

    .btn-width {
        width: 100%;
    }
</style>